import { Cookies } from 'react-cookie';
import { BrowserStorage } from '@atc/browser-storage';
const oneYearInSeconds = 365 * 24 * 60 * 60;
const thirtyDaysInMS = 30 * 24 * 60 * 60 * 1000;
let cookies;
const getCookies = () => {
  if (!cookies) {
    cookies = new Cookies();
  }
  return cookies;
};
let storage;
const getStorage = () => {
  if (!storage) {
    storage = new BrowserStorage('ATC_PIXALL', {
      persist: true
    });
  }
  return storage;
};

// This script maintains the 'pixall_abc' cookie as a cache of the _third_ party Pixall Visitor Id to reduce fetches.
const pixallAbcCookieName = 'pixall_abc';
let pixallAbc = '';
export const setPixallAbc = x => {
  pixallAbc = x;
  getCookies().set(pixallAbcCookieName, x, {
    path: '/',
    maxAge: oneYearInSeconds
  });
  // set expiration shorter than actual cookie expiration to avoid lapses
  getStorage().setItem({
    expiration: Date.now() + thirtyDaysInMS
  });
};
export const initPixallAbc = () => {
  // Pixall should run the following line whenever it creates an abc value:
  // window.setPixallAbc ? window.setPixallAbc(abc) : window.pixallAbc = abc;

  // If Pixall has already run, this detects the set value.
  if (global.pixallAbc) {
    setPixallAbc(global.pixallAbc);
  } else {
    // Otherwise, this exposes a function for the Pixall to call when it runs.
    global.setPixallAbc = setPixallAbc;
  }
};
const getPixallAbcFromCookies = () => {
  if (pixallAbc) {
    return {
      pixallId: pixallAbc,
      isFetchNewPixallId: false
    };
  }
  const abc = getCookies().get(pixallAbcCookieName, {
    doNotParse: true
  });
  if (!abc) {
    return {
      pixallId: null,
      isFetchNewPixallId: true
    };
  }
  pixallAbc = abc;
  const {
    expiration
  } = getStorage().getItem() || {};

  // If the value is stale, use it anyway but issue a non-blocking update (no `await`) to extend the
  // expiration of the cookie (To be safe, the value is updated also, but in practice it should never
  // change).
  if (Date.now() > (Number(expiration) || 0)) {
    return {
      pixallId: pixallAbc,
      isFetchNewPixallId: true
    };
  }
  return {
    pixallId: pixallAbc,
    isFetchNewPixallId: false
  };
};

// Return the _first_ party Pixall visitor ID. The cookie is managed by the Pixall script.
export const getFirstPartyVistorId = () => getCookies().get('pxa_id', {
  doNotParse: true
}) || '';
const getPixallId = () => getCookies().get('abc') || getCookies().get('pxa_id');
export const getPixallIdFromCookie = () => {
  const {
    pixallId
  } = getPixallAbcFromCookies();
  return pixallId || getFirstPartyVistorId();
};
export default getPixallId;